<div class="inbox-task-skeleton" *ngFor="let _ of skeletonItems">
  <div class="checkbox-placeholder"></div>
  <div class="content">
    <div class="title-line">
      <div class="skeleton-title"></div>
    </div>
    <div class="description-line">
      <div class="skeleton-description"></div>
    </div>
    <div class="metadata-line">
      <div class="skeleton-tag"></div>
      <div class="skeleton-tag"></div>
      <div class="skeleton-date"></div>
    </div>
  </div>
</div>
